import { render, staticRenderFns } from "./EditMntQuestion.vue?vue&type=template&id=47cb5fd7"
import script from "./EditMntQuestion.vue?vue&type=script&lang=js"
export * from "./EditMntQuestion.vue?vue&type=script&lang=js"
import style0 from "./EditMntQuestion.vue?vue&type=style&index=0&id=47cb5fd7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports